import React from "react";
import styled from "@emotion/styled";

import AreaTypes from "types/AreaTypes";
import PathTypes from "types/PathTypes";
import PointTypes from "types/PointTypes";

import Chip from "@mui/material/Chip";

import ParkkiTheme from "themes/ParkkiTheme";

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "backgroundColor",
})`
  margin-right: ${ParkkiTheme.spacings.teeny};
  margin-top: ${ParkkiTheme.spacings.teeny};
  background-color: ${(props: { backgroundColor: string }) =>
    props?.backgroundColor || "default"};
`;

type Props = {
  layers: AreaTypes[] | PointTypes[] | PathTypes[];
  onSelectLayers: Function;
  color?: string;
};

function SelectedChips({ layers, color, onSelectLayers }: Props): JSX.Element {
  function handleUnselectLayer(
    layerToUnselect: AreaTypes | PointTypes | PathTypes
  ) {
    const newlySelectedLayers = layers
      // @ts-ignore
      .filter((layer) => layer.id !== layerToUnselect.id)
      // @ts-ignore
      .filter((layer) => layer.selected);

    return onSelectLayers(newlySelectedLayers);
  }

  return (
    <>
      {layers
        // @ts-ignore
        .filter((layer) => layer.selected)
        .map((layer: PathTypes | PointTypes | AreaTypes, index: number) => (
          <StyledChip
            key={index}
            size="small"
            label={layer.short_name || layer.long_name || layer.id}
            backgroundColor={color || "primary"}
            color="primary"
            onDelete={() => handleUnselectLayer(layer)}
          />
        ))}
    </>
  );
}

export default SelectedChips;
